import React, { useState } from "react";
import "../../page_content.css";

const SampleCV = () => {
  return (
    <div>
      <h1 className="title">Sample CV</h1>
      <hr />
      <div className="page-content-container" id="page-links">
        <p>
         To download the standard format of CV :
        </p>
        <a
          href="https://docs.google.com/document/d/1wVjTBIRyIqyGWZ26j2m1sck8Hm3IENx6/edit"
          download
        >
          <button>Click Here</button>
        </a>
      </div>
    </div>
  );
};

export default SampleCV;
